export default __webpack_public_path__ + "static/media/calculations.f4c868e6.svg";